import React, { Component } from 'react'
import Card from "Utils/Cards/Card"
import AdministrativosEnCurso from "./InvestmentsInPorgressList"
import Tabs, { TabPane } from "rc-tabs";
import CardEmpty from '../../../../Utils/Cards/CardEmpty';
import InvestmentsListAnnual from '../Anuales/List/AnnualListBudgets'
import CurrentListTotal from '../Anuales/List/CurrentListTotal'
import { Link } from 'react-router-dom';

export default class InvestmentsSummary extends Component {
    componentDidMount() {
        const { getInvestmentsDetail, page, tab, read_annual } = this.props;

        if (tab === 'EN_CURSO') {
            getInvestmentsDetail(page);
        } else {
            read_annual()
        }

    }

    render() {
        const { setTab, tab, item } = this.props;
        return (
            <div className="mb-4 col-12">
                <Card noShadow
                    icon="Side_activos/Admin.svg"
                    titulo="PRESUPUESTO DE INVERSIONES"
                    subtitulo="RESUMEN"
                    noBorder
                >
                    <Tabs
                        defaultActiveKey={tab}
                        onChange={tab => { setTab(tab) }}
                        moreIcon={<span className='icon-more-icon'>+</span>}
                    >
                        <TabPane tab="EN CURSO" key="EN_CURSO">
                            <CardEmpty noShadow>
                                <div className="row col-md-12 p-0 mt-2 mb-4">
                                    <div className="col-md-6">
                                        <h4 className="mr-2 titulo_principal">PRESUPUESTO DE INVERSIONES</h4>
                                    </div>
                                </div>
                                <div className='mb-4'>
                                    <AdministrativosEnCurso {...this.props} dollar_exchange={item} />
                                </div>
                            </CardEmpty>
                        </TabPane>
                        <TabPane tab="PROYECCIONES ANUALES" key="PROYECCIONES_ANUALES">
                            <CardEmpty noShadow>


                                <div className="row col-md-12 p-0">
                                    <div className="col-md-6">
                                        <h4 className="mr-2 titulo_principal">PRESUPUESTO DE INVERSIONES</h4>
                                    </div>
                                    <div className="col-md-6 d-grid gap-2 d-md-flex justify-content-md-end">
                                        <Link className="btn btn-primary mb-4" to="annual/crear">Agregar</Link>
                                    </div>
                                </div>

                                <InvestmentsListAnnual {...this.props} />
                                <div className="row col-md-12 mt-4 p-0">
                                    <div className="col-md-6">
                                        <h4 className="mr-2 titulo_principal">INVERSIONES DEL PRESUPUESTO EN CURSO</h4>
                                    </div>
                                </div>
                                <CurrentListTotal {...this.props}/>
                            </CardEmpty>
                        </TabPane>
                    </Tabs>

                </Card>
            </div>
        )
    }
}